export default __webpack_public_path__ + "static/media/background.8bdfc51a.jpg";